import { render, staticRenderFns } from "./DashboardMaintenanceHistoryView.vue?vue&type=template&id=ac881248&scoped=true&"
import script from "./DashboardMaintenanceHistoryView.vue?vue&type=script&lang=js&"
export * from "./DashboardMaintenanceHistoryView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMaintenanceHistoryView.vue?vue&type=style&index=0&id=ac881248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac881248",
  null
  
)

/* custom blocks */
import block0 from "./DashboardMaintenanceHistoryView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports